<template>
	<div class="">
		<vm-header></vm-header>
		<div class="container centea">
			<div class="one">
				<div class="xinxi1"><img src="../../../static/img/p2.png"><a href="">根据您的筛选条件您适合选考的科目为：</a></div>
				<div class="da">
					<div class="xinxi"><span>物理 </span> </div>
					<div class="xinxi"><span>化学 </span> </div>
					<div class="xinxi"><span>生物 </span> </div>
					<div class="xinxi2">保存</div>
				</div>
			
			</div>
			<div class="topsd">
				<div class="intro1-tit">
					<div class="wl"></div>
					<span>选考科目及对应可报专业情况</span>
				</div>
				<ul>
					<li>
						<span></span>
						<span>人数</span>
					</li>
					<li>
						<span></span>
						<span>比例</span>
					</li>
				</ul>
			</div>
			<wodexuanke></wodexuanke>
			
			<!-- <div class="query">
				<div class="query_top">
					<p>院校：</p>
					<input type="text" placeholder="查询院校名称">
				</div>
				<div class="query_top">
					<p>专业：</p>
					<input type="text" placeholder="查询专业名称">
				</div>
				<div class="query_bot">
					<img src="../../assets/img/tbfdj.png" alt="">
					<p>查询志愿</p>
				</div>
			</div> -->
			<div class="container_text">
				选考方案及匹配专业情况
			</div>
			<div class="tablecon">
				<div class="two" v-for="(item, index) in Title" :key="index">
					<div class="T_title0">{{ item.til0 }}</div>
					<div class="T_title1">{{ item.til1 }}</div>
					<div class="T_title2">{{ item.til2 }}</div>
					<div class="T_title6">{{ item.til6 }}</div>
					<div class="T_title7">{{ item.til7 }}</div>
					<div class="T_title8">
						<div class="T_title8top">{{ item.til8 }}</div>
						<div class="T_title8bot">
							<div>{{ item.til9 }}</div>
							<div>{{ item.til10 }}</div>
							<div>{{ item.til11 }}</div>
							<div>{{ item.til12 }}</div>
							<div>{{ item.til13 }}</div>
						</div>
					</div>
					<!-- <div class="T_title9">{{ item.til14 }}</div> -->
				</div>
				<div class="three">
					<div class="three_for" v-for="(item, index1) in arr" :key="index1">
						<div class="Cont Cont0">
							<p :class="item.classSS1">{{ item.A1 }}</p>
							<p :class="item.classSS2">{{ item.A2 }}</p>
							<p :class="item.classSS3">{{ item.A3 }}</p>
						</div>
						<div class="Cont Cont1">
							<div class="Cont_TP">
								<img :src="item.AiMg" alt="">
								<p>{{item.Tx}}</p>
							</div>
							<div class="Cont_Nr">
								<p>{{ item.title }}</p>
								<h2>{{item.xiaoqu}}</h2>
								<div class="Cont_Nr_xinxi">
									<p>{{item.leixing}} <span>{{item.leixingd}}</span></p>
									<p>{{item.xingzhi}}<span>{{item.xingzhid}}</span></p>
								</div>
								<div class="Cont_Card">
									<span v-for="(list, index12) in item.arr1"
										:key="index12 + 11">{{ list.text }}</span>
								</div>
								<div class="Cont_Nr_dw">{{item.dw}}</div>
							</div>
						</div>
						<div class="Cont Cont2">
							<div class="Cont2_top">
								<p>{{ item.sort }}</p>
								<h4>代码：</h4><span>{{item.daima}}</span>
							</div>
							<div class="Cont2_bot">
								<p>{{ item.zhuanyecon }}</p>
							</div>
						</div>
						<div class="Cont Cont6">
							<p>{{ item.education }}</p>
						</div>
						<div class="Cont Cont7">
							<p>{{ item.nature }}</p>
						</div>
						<div class="Cont Cont8 ">
							<div :class="data.class" v-for="(data, index2) in item.arr2" :key="index2" class="sdk">
								<div class="Cont8_B">{{ data.Cont1 }}</div>
								<div class="Cont8_B">{{ data.Cont2 }}</div>
								<div class="Cont8_B">{{ data.Cont3 }}</div>
							</div>
						</div>
						<!-- <div class="Cont Cont9">
							<div :class="item.classA" @click="zzc()">
								<p>{{ item.gz1 }}</p>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<item7></item7>
	</div>
</template>

<script>
	import vmHeader from '../../components/vmHeader.vue'
	import item7 from '../../components/item7.vue'
import wodexuanke from '../tubiao/wodexuanke.vue'
	export default {
		name: "",
		components: {
			wodexuanke,
			vmHeader,
			item7
		},
		data() {
			return {
				// 用来标识遮罩层显示与隐藏的
				isTrue: false,
				// 标题
				Title: [{
					til0: '风险系数',
					til1: "院校信息",
					til2: "专业信息",
					til6: "选科",
					til7: "当年计划",
					til8: "成绩",
					til9: "年份",
					til10: "录取数",
					til11: "最低分",
					til12: "位次",
					til13: "线差",
					til14: "操作",
				}, ],
				// 学校渲染
				arr: [{
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1',
					classSS2: 'Cont0_B1',
					classSS3: 'Cont0_C1',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_B",
					gz1: "已填报",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1',
					classSS2: 'Cont0_B1',
					classSS3: 'Cont0_C1',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_B",
					gz1: "已填报",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1 Cont0_A2',
					classSS2: 'Cont0_B1 Cont0_B2',
					classSS3: 'Cont0_C1 Cont0_C2',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_A",
					gz1: "填报志愿",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1 Cont0_A2',
					classSS2: 'Cont0_B1 Cont0_B2',
					classSS3: 'Cont0_C1 Cont0_C2',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_B",
					gz1: "已填报",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1 Cont0_A3',
					classSS2: 'Cont0_B1 Cont0_B3',
					classSS3: 'Cont0_C1 Cont0_C3',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_B",
					gz1: "已填报",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1 Cont0_A3',
					classSS2: 'Cont0_B1 Cont0_B3',
					classSS3: 'Cont0_C1 Cont0_C3',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_A",
					gz1: "填报志愿",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1 Cont0_A4',
					classSS2: 'Cont0_B1 Cont0_B4',
					classSS3: 'Cont0_C1 Cont0_C4',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_B",
					gz1: "已填报",
				}, {
					AiMg: require("../../assets/img/tuceng5.png"),
					Tx: '代码:2415',
					A1: '15%',
					A2: '风险评估',
					A3: '风险高',
					classSS1: 'Cont0_A1 Cont0_A4',
					classSS2: 'Cont0_B1 Cont0_B4',
					classSS3: 'Cont0_C1 Cont0_C4',
					title: "北京航空航天大学",
					xiaoqu: '(盘锦校区)(中外合作办学)',
					leixing: '类型：',
					leixingd: '综合',
					xingzhi: '性质：',
					xingzhid: '公立',
					dw: '北京',
					arr1: [{
						text: "双一流、211、北京市重点大学、研究生院"
					}, ],
					sort: "经济学类",
					daima: '12034',
					zhuanyecon: '专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专业内容专专业内容......',
					region: "河南",
					overall: "河南省教育厅",
					member: "公立",
					education: "物理+化学+生物",
					nature: "---",
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: "Cont8_A Cont8_AA",
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: "Cont8_A"
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: "Cont8_A"
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: "Cont8_A"
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: "Cont8_A"
						},
					],
					classA: "Cont9_A",
					gz1: "填报志愿",
				}],
			}
		},
		methods: {
			zzc() {
				this.isTrue = true;
			},
			zzcB() {
				this.isTrue = false;
			},
		}


	}
</script>

<style scoped>
	.topsd{height: 60px;margin: 0 auto; width: 97%;align-items: center;display: flex;justify-content: space-between;border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);}
	.topsd ul{display: flex;align-items: center;margin-bottom: 0;}
	.topsd ul li {display: flex;align-items: center;margin-left: 25px;}
	.topsd ul li span:nth-of-type(1){width: 36px;height: 20px;border-radius: 5px;display: flex;}
	.topsd ul li span:nth-of-type(2){font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #333333;margin-left: 8px;}
	.topsd ul li:nth-of-type(1) span:nth-of-type(1){background: rgba(41, 167, 225, 1);opacity: 1;}
	.topsd ul li:nth-of-type(2) span:nth-of-type(1){background: rgba(254, 150, 3,1);opacity: 1;}
	.intro1-tit{display: flex;}
	.intro1-tit span {margin-left: 10px;font-size: 20px;font-family: PingFang SC;font-weight: 500;color: #333333;line-height: 20px;display: flex;align-items: center;}
	.wl {width: 6px;height: 22px;border-radius: 0px 4px 4px 0px;background: #F21323;}
	.container_text{font-size: 20px;font-family: PingFang SC;font-weight: 500;color: #29A7E1;line-height: 50px;}
	
	
	.da {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.one {
		margin-top: 20px;
		justify-content: left;
		width: 100%;
		height: 60px;
		background: rgba(255, 255, 255, 0.39);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
		border-radius: 5px;
		display: flex;
		padding-left: 20px;
	}
	
	.one span {
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666;
	}
	.xinxi1 {
		margin-right: 17px;
		display: flex;
		align-items: center;
	
	}
	
	.xinxi1 a {
		padding-left: 9px;
		text-decoration: none;
		color: #29A7E1;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
	
	}
	
	.xinxi img {
		width: 8px;
		height: 8px;
	}
	
	.xinxi {
		padding: 0 5px 0 5px;
		width: auto;
		height: 30px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #29A7E1;
		opacity: 1;
		border-radius: 5px;
		line-height: 30px;
		margin-right: 50px;
	}
	.xinxi2{
		width: 76px;
		height: 34px;
		background: linear-gradient(180deg, #29A7E1 0%, #3EC2FF 100%);
		opacity: 1;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	
	.xinxi span {
		text-align: center;
		font-size: 14px;
		text-decoration: none;
		color: #29A7E1;
		font-family: PingFang SC;
		font-weight: 500;
	
	}
	
	@media (max-width:750px) {
		.container {
			width: auto;
		}
	
		.shuru {
			display: block !important;
		}
	
		.xinxi {
			margin-right: 10px;
		}
	
		.one {
			width: auto;
			display: flex;
			align-items: flex-start;
			flex-direction: column;
			height: auto;
			padding: 10px 5px;
		}
		.xinxi1{margin-bottom: 10px;}
		.topsd{flex-direction: column;align-items: flex-start;height: auto;padding: 10px 5px;}
		.intro1-tit{margin-bottom: 15px;}
	}
	
	
	
	@media (min-width:1400px) {
		.centea {
			width: 1458px;
			box-sizing: border-box;
		}
	}
	.sdk:nth-of-type(5){
		border: none!important;
	}
	.query {
		width: 100%;
		height: 64px;
		background: rgba(248, 248, 248, 0.39);
		border-radius: 5px;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		margin-top: 20px;
	}
	
	.query .query_top {
		display: flex;
	}
	
	.query_top p {
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		display: flex;
		align-items: center;
	}
	
	.query_top input {
		width: 320px;
		height: 40px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #E0E0E0;
		opacity: 1;
		border-radius: 5px;
		padding-left: 10px;
		box-sizing: border-box;
	}
	
	::-webkit-input-placeholder {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #999999;
	}
	
	.query_bot {
		width: 100px;
		height: 40px;
		background: linear-gradient(180deg, #29A7E1 0%, #3EC2FF 100%);
		opacity: 1;
		border-radius: 4px;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		cursor: pointer;
	}
	
	.query_bot img {
		width: 14px;
		height: 14px;
	}
	
	.query_bot p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	
	.centea {
		/* padding-left: 0 !important;
		padding-right: 0 !important; */
		padding: 10px;
		box-sizing: border-box;
	}
	
	/* 表格表头 */
	.two {
		display: flex;
		width: 100%;
		height: 100px;
		background-color: #f66464;
		margin-top: 20px;
		border-radius: 2px;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 50px;
		color: #ffffff;
		justify-content: center;
		align-items: center;
	}
	
	.two .T_title0 {
		width: 8%;
		text-align: center;
	}
	
	.two .T_title1 {
		width: 25%;
		text-align: center;
	}
	
	.two .T_title2 {
		width: 15%;
		text-align: center;
	}
	
	.two .T_title6 {
		width: 11%;
		text-align: center;
	}
	
	.two .T_title7 {
		width: 9%;
		text-align: center;
	}
	
	.two .T_title8 {
		width: 32%;
		text-align: center;
		display: flex;
		flex-direction: column;
		border-left: 1px solid rgba(255, 255, 255, 0.3);
		border-right: 1px solid rgba(255, 255, 255, 0.3);
	}
	
	.T_title8top {
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid rgba(255, 255, 255, 0.3);
	}
	
	.T_title8bot {
		display: flex;
		justify-content: space-evenly;
	}
	
	.two .T_title9 {
		width: 10%;
		text-align: center;
	}
	
	/* 中间内容 */
	.three {
		width: 100%;
		height: auto;
		margin-top: 11px;
		margin-bottom: 55px;
	}
	
	.three .three_for {
		display: flex;
		width: 100%;
		height: 169px;
		border: 1px solid #ebe9e9;
		border-radius: 10px;
		margin-top: 11px;
	}
	
	.three .Cont0 {
		width: 8%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.Cont0 .Cont0_A1 {
		font-size: 28px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 40px;
		color: #FF513E;
	}
	
	.Cont0 .Cont0_A2 {
		color: #29A7E1 !important;
	}
	
	.Cont0 .Cont0_A3 {
		color: #00B54F !important;
	}
	
	.Cont0 .Cont0_A4 {
		color: #CFB400 !important;
	}
	
	.Cont0 .Cont0_C2 {
		background: #29A7E1 !important;
	}
	
	.Cont0 .Cont0_C3 {
		background: #00B54F !important;
	}
	
	.Cont0 .Cont0_C4 {
		background: #CFB400 !important;
	}
	
	.Cont0 .Cont0_B1 {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 17px;
		color: #999999;
	}
	
	.Cont0 .Cont0_C1 {
		width: 68px;
		height: 22px;
		display: block;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		text-align: center;
		line-height: 22px;
		background: #F53824;
		border-radius: 11px;
		margin-top: 12px;
	}
	
	.three .Cont1 {
		width: 25%;
		height: 100%;
		display: flex;
		padding-left: 18px;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}
	
	.three .Cont {
		border-right: 1px solid #ebe9e9;
	}
	
	.three .Cont2 {
		width: 15%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 18px;
	}
	
	.three .Cont6 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 12%;
		height: 100%;
		text-align: center;
	}
	
	.three .Cont7 {
		width: 8%;
		height: 100%;
		text-align: center;
		line-height: 169px;
	}
	
	.three .Cont8 {
		width: 32%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-evenly;
		border: none;
	}
	
	.Cont8_A {
		width: 20%;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		border-right: 1px solid #ebe9e9;
	}
	
	.Cont8_AA {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29a7e1;
	}
	
	.Cont8_B {
		width: 100%;
		height: 33.33333%;
		border-bottom: 1px solid #ebe9e9;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.three .Cont9 {
		width: 10%;
		height: 100%;
		text-align: center;
		line-height: 169px;
		border: none;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.Cont9 .Cont9_A {
		display: flex;
		justify-content: center;
		width: 92px;
		height: 36px;
		border: 1px solid #F53824;
		border-radius: 5px;
		align-items: center;
		cursor: pointer;
	}
	
	/* 点击关注 切换 */
	.Cont9 .Cont9_B {
		display: flex;
		justify-content: center;
		width: 92px;
		height: 36px;
		background: #F53824;
		background-size: 92px 36px;
		align-items: center;
		cursor: pointer;
		color: white;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		border-radius: 5px;
	}
	
	.Cont9_A p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #F53824;
	}
	
	.Cont_img {
		width: 110px;
		height: 110px;
	}
	
	.Cont_TP {
		display: flex;
		flex-direction: column;
	}
	
	.Cont_TP img {
		width: 68px;
		height: 68px;
	}
	
	.Cont_TP p {
		display: block;
		width: 68px;
		height: 28px;
		background: rgba(242, 242, 242, 0.39);
		border-radius: 5px;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #F53824;
		text-align: center;
		line-height: 28px;
		margin-top: 12px;
	}
	
	.Cont_Nr {
		flex: 1;
		margin-left: 14px;
		position: relative;
	}
	
	.Cont_Nr p {
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}
	
	.Cont_Nr h2 {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #666666;
		margin-top: 8px;
	}
	
	.Cont_Nr_xinxi {
		display: flex;
	}
	
	.Cont_Nr_xinxi p {
		color: #999999;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 18px;
		margin-right: 20px;
		margin-top: 12px;
	}
	
	.Cont_Nr_xinxi span {
		color: #333333;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 18px;
	}
	
	.Cont_Card {
		margin-top: 12px;
	}
	
	.Cont_Card span {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 18px;
		color: #333333;
		opacity: 1;
	}
	
	.Cont_Nr_dw {
		position: absolute;
		top: 10px;
		right: 69px;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
	}
	
	.Cont2 .Cont2_top {
		display: flex;
		margin-bottom: 9px;
	}
	
	.Cont2 .Cont2_top p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #29A7E1;
		margin-right: 20px;
	}
	
	.Cont2_top h4,
	span {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #F53824;
	}
	
	.Cont2_bot p {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 17px;
		color: #999999;
		opacity: 1;
	}
	
	.Cont6 p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #333333;
	}
	
	.three_for .Cont3 p,
	.three_for .Cont4 p,
	.three_for .Cont5 p,
	.three_for,
	.three_for .Cont7 p {
		font-size: 16px;
		font-family: MicrosoftYaHei;
		color: #333333;
	}
	
	/* 遮罩层  ↓ */
	.mask {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.7);
	}
	
	.maskA {
		width: 910px;
		height: 810px;
		background: rgb(255, 255, 255);
		border-radius: 20px 20px 0px 0px;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		overflow: hidden;
	}
	
	.maskAA {
		width: 910px;
		height: 64px;
		background-image: url("../../assets/img/zzctop.png");
		background-size: 100% 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 28px;
		padding-left: 28px;
		box-sizing: border-box;
	}
	
	.maskAA p {
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #ffffff;
	}
	
	.maskAA img {
		cursor: pointer;
	}
	
	/* 遮罩层内容 */
	.mask_nr {
		padding: 20px;
		box-sizing: border-box;
	}
	
	@media (max-width:750px) {
		.query {
			flex-direction: column;
			margin-top: 40px;
			margin-bottom: 55px;
		}
	
		.query_top {
			margin-top: 10px;
		}
	
		.query_top input {
			width: 220px;
		}
	
		.query_bot {
			margin-top: 10px;
			line-height: 37px;
		}
	
		.two {
			width: 1500px;
		}
	
		.tablecon {
			overflow: auto;
		}
	
		.three {
			width: 1500px;
		}
	
		.maskA {
			width: 80%;
			height: 80%;
		}
	
		.maskAA {
			width: 100%;
		}
	
		.maskAA p {
			font-size: 15px;
		}
	}
	
	@media (max-width:980px) {
		.query {
			margin-top: 40px;
			margin-bottom: 55px;
		}
	
		.query_top {
			margin-top: 10px;
		}
	
		.query_top input {
			width: 220px;
		}
	
		.query_bot {
			margin-top: 10px;
			line-height: 37px;
		}
	
		.two {
			width: 1500px;
		}
	
		.tablecon {
			overflow: auto;
		}
	
		.three {
			width: 1500px;
		}
	}
	
	@media (max-width:1400px) {
		.query {
			margin-top: 40px;
			margin-bottom: 55px;
		}
	
		.query_top {
			margin-top: 10px;
		}
	
		.query_top input {
			width: 220px;
		}
	
		.query_bot {
			margin-top: 10px;
			line-height: 37px;
		}
	
		.two {
			width: 1500px;
		}
	
		.tablecon {
			overflow: auto;
		}
	
		.three {
			width: 1500px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/g_zhinengxuankejieguoye.vue